var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplashThamMy = function SvgSplashThamMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M9.713 15.625a8.752 8.752 0 0 0 17.323 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    strokeLinecap: "round",
    d: "M22.438 8.828a6.875 6.875 0 0 0-8.948 10.384m10.118-9.296a6.875 6.875 0 0 1-7.828 10.827"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M14.882 20.025a.418.418 0 1 1-.835 0 .418.418 0 0 1 .835 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    strokeLinecap: "round",
    d: "M19.938 25.336h-4.563a2 2 0 0 0-2 2v0a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.125c0-1.035-.84-1.875-1.875-1.875v0h-.156"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M25.25 15.625h1.25a1.25 1.25 0 1 0 0-2.5h-1.25M11.5 15.625h-1.25a1.25 1.25 0 1 1 0-2.5h1.25M18.375 23.125v2.188"
  }))));
};
export default SvgSplashThamMy;